import type { PlayItem } from "@ca.vmedia.tv/domains";
import { useGenresStore } from "@/stores/Genres";
import type { ExposeInterface } from './types';


export const useDetailPageStore = defineStore('DetailPage', (): ExposeInterface => {
    const { getGenre } = useGenresStore();

    const _viewedDetailItems: Ref<PlayItem[] | null> = ref(null);
    const viewedDetailItems = computed((): PlayItem[] | null => _viewedDetailItems.value);
    const setViewedDetailItems = (item: PlayItem): void => {
        if (!_viewedDetailItems.value) {
            _viewedDetailItems.value = [item];
        } else {
            _viewedDetailItems.value.push(item);
        }
    };

    const _currentItemDetail: Ref<PlayItem | null> = ref(null);
    const setCurrentItemDetail = (id: string): void => {
        if (id && viewedDetailItems.value && viewedDetailItems.value.length > 0) {
            _currentItemDetail.value = viewedDetailItems.value.find((item: PlayItem) => item.id === Number(id)) ?? null;
        }
    };
    const getCurrentItemDetail: ComputedRef<PlayItem | null> = computed(() => _currentItemDetail.value);

    const _isPlayStatusChanging: Ref<boolean> = ref(false);
    const getPlayStatusChanging: ComputedRef<boolean> = computed(() => _isPlayStatusChanging.value);
    const setPlayStatusChanging = (value: boolean): void => {
        _isPlayStatusChanging.value = value;
    };
    
    const _isProgramModalVisible: Ref<boolean> = ref(false);
    const getProgramModalVisible: ComputedRef<boolean> = computed(() => _isProgramModalVisible.value);
    const showProgramModal = (): void => {
        _isProgramModalVisible.value = true;
    };
    const hideProgramModal = (): void => {
        _isProgramModalVisible.value = false;
    };

    const _isSeasonModalVisible: Ref<boolean> = ref(false);
    const getSeasonModalVisible: ComputedRef<boolean> = computed(() => _isSeasonModalVisible.value);
    const showSeasonModal = () => {
        _isSeasonModalVisible.value = true;
    };
    const hideSeasonModal = () => {
        _isSeasonModalVisible.value = false;
    };

    const _playBtnUnavailable: Ref<boolean> = ref(false);
    const getPlayBtnUnavailable: ComputedRef<boolean> = computed(() => _playBtnUnavailable.value);
    const setPlayBtnUnavailable = (value: boolean): void => {
        _playBtnUnavailable.value = value;
    };

    const _convertedGenres: Ref<string[]> = ref([]);
    const getConvertedGenres: ComputedRef<string[]> = computed(() => _convertedGenres.value);
    const setConvertedGenres = (items: string[]): void => {
        _convertedGenres.value = items;
    };
    const convertGenres = (genreIds: number[] | null): void => {
        if (genreIds) {
            const genreNames: string[] = [];
            genreIds.slice(0, 3).forEach((id: number) => {
                const genre = getGenre(id);
                if (genre && genre.name !== null) {
                    genreNames.push(genre.name);
                }
            });

            _convertedGenres.value = genreNames;
        } else {
            _convertedGenres.value = [];
        }
    };

    const clearAllDetailPage = (): void => {
        _currentItemDetail.value = null;
        _isProgramModalVisible.value = false;
        _isSeasonModalVisible.value = false;
        _playBtnUnavailable.value = false;
        _convertedGenres.value = [];
        _viewedDetailItems.value = [];
    };

    return {
        getProgramModalVisible,
        getSeasonModalVisible,
        getPlayBtnUnavailable,
        getCurrentItemDetail,
        getConvertedGenres,
        convertGenres,
        setCurrentItemDetail,
        setConvertedGenres,
        showProgramModal,
        hideProgramModal,
        showSeasonModal,
        hideSeasonModal,
        setPlayBtnUnavailable,
        clearAllDetailPage,
        viewedDetailItems,
        setViewedDetailItems,
        getPlayStatusChanging,
        setPlayStatusChanging
    };
});
